import {Pipe, PipeTransform} from '@angular/core';
import {Drawing} from '../classes/drawing';
import {Utils} from '../utils.class';

@Pipe({
    name: 'orderDrawings'
})
export class OrderDrawingsPipe implements PipeTransform {

    transform(drawings: Drawing[], ...args: unknown[]): Drawing[] {
        return drawings.sort((a, b) => {
            if ((a.entities_count > 0) === (b.entities_count > 0)) {
                return (Utils.getDateGetTime(a.date) < Utils.getDateGetTime(b.date) ? 1 : -1);
            }
            return (a.entities_count > 0 ? -1 : 1) - (b.entities_count > 0 ? -1 : 1);
        });
    }

}
